import * as React from 'react';
import {
    FilterList,
    FilterListItem,
    FilterButton,
    SearchInput,
    FilterForm,
    Button,
    useListContext,
} from 'react-admin';
import { Box, Stack } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

import { useConfigurationContext } from '@app/root/ConfigurationContext';

export const AntennaListFilter = () => {
    const { antennaTypes } = useConfigurationContext();
    const { setFilters, filterValues } = useListContext();

    const antennaFilters = [
        <SearchInput
            key="search"
            source="search"
            alwaysOn
            placeholder="Search name, description..."
        />,
    ];

    const hasFilters = filterValues && Object.keys(filterValues).length > 0;

    const handleClearFilters = () => {
        setFilters({});
    };

    return (
        <Box width="13em" minWidth="13em" order={-1} mr={2} mt={5}>
            <Stack flexDirection="row" justifyContent="space-between">
                <FilterButton filters={antennaFilters} />
                <Button
                    disabled={!hasFilters}
                    label="Clear all"
                    onClick={handleClearFilters}
                    variant="outlined"
                    size="small"
                />
            </Stack>
            <FilterForm filters={antennaFilters} />

            <FilterList label="Type" icon={<LocalShippingIcon />}>
                {antennaTypes.map(type => (
                    <FilterListItem
                        key={type.value}
                        label={
                            <Box
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 4,
                                }}
                            >
                                <type.icon /> {type.label}
                            </Box>
                        }
                        value={{ type: type.value }}
                    />
                ))}
            </FilterList>
        </Box>
    );
};
